<script>
export default {
  name: 'AlertNotification',
  props: {
    iconImage: {
      type: String,
      required: true
    },
    textMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    imageFallBack(event) {
      const image = require.context('@assets/images/', false, /\.png$/)
      event.target.src = image('./info@3x.png')
    },
  }
}
</script>

<template>
  <div :class="$style.alertContainer">
    <div :class="$style.alertContainer__icon">
      <img
        :class="$style.alertContainer__image"
        :src="iconImage"
        @error="imageFallBack">
    </div>
    <div :class="$style.alertContainer__message">
      <p><span v-html="textMessage"/></p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
